<app-navbar-tree />
<div [class.mw-xs-xl-1280p]="loggedIn && !isMobile" [class.mw-xl-1280p]="loggedIn && isMobile">
  <app-header-message />
  <tooltip />
  <div appContainer>
    <router-outlet />
  </div>
  @if (loggedIn) {
    <app-maintenance-banner />
  }
  <app-consent-modal />
</div>
<app-toast-container aria-live="polite" aria-atomic="true" />
